export default {
    spanish: require('./mexico.svg'),
    english: require('./usa.svg'),
};
